/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { StoreCard } from '@cash-rewards/cr-ui-components';
import { clsxm } from '@cash-rewards/reactjs';

import ImpressionPixel from '@/modules/shop/components/ImpressionPixel';
import { StoreAdModel } from '@/modules/shop/models/offerModels';

interface StoreAdCarouselCardProps {
  store: StoreAdModel;
  className: string;
  impressionUrl?: string;
}
const StoreAdCarouselCard = ({
  store,
  className,
  impressionUrl,
  ...rest
}: StoreAdCarouselCardProps) => {
  return (
    <div className={clsxm('w-[256px] ', className)}>
      <StoreCard
        isAdvert={store.isAdvert}
        logoUrl={
          store.merchantLogoOverride
            ? store.merchantLogoOverride
            : store.merchantLogo!
        }
        merchantName={store.brandNameInBold ?? store.merchantName ?? ''}
        commissionString={
          store.highlightCopyInPurpleBold ??
          store.merchantCommissionString ??
          'Learn more'
        }
        href={`${store.adClickUrl}`}
        {...rest}
      ></StoreCard>
      <ImpressionPixel impressionUrl={impressionUrl} />
    </div>
  );
};

export default StoreAdCarouselCard;
